import { useEffect, useState } from "react";

/**
 * Ürün kataloğu — tek kaynak.
 *
 * Her marka/tedarikçi grubu public/data altında kendi dosyasında tutulur
 * (boya-urunleri.json, izeltas-urunleri.json, ...). Yeni bir marka eklenince
 * sadece bu listeye dosya adını eklemek yeterli: katalog, ürün detay sayfası
 * ve ana sayfa aynı listeyi kullanır.
 *
 * Sıra "Yeni Eklenenler" için de kullanılır: listenin sonundakiler en yeni.
 */
export const URUN_DOSYALARI = [
  "boya-urunleri.json",
  "izeltas-urunleri.json",
  "sgs-urunleri.json",
  "dekor-urunleri.json",
  "akan-urunleri.json",
  "attlas-urunleri.json",
  "kilsan-urunleri.json",
  "ytong-urunleri.json",
  "kalde-urunleri.json",
  "atlas-zimpara-urunleri.json",
  "filli-urunleri.json",
  "polisan-urunleri.json",
  "permolit-urunleri.json",
  "bianca-urunleri.json",
  "stella-urunleri.json",
  "kalekim-urunleri.json",
  "eca-urunleri.json",
  "vitra-urunleri.json",
  "creavit-urunleri.json",
  "dekor-firca-urunleri.json",
  "selsil-urunleri.json",
  "yapi-malzemeleri-urunleri.json",
  "kaynak-urunleri.json",
  "isg-urunleri.json",
  "soudal-akfix-urunleri.json",
  "bosch-makita-uc-urunleri.json",
  "elektrik-urunleri.json",
  "dewalt-urunleri.json",
  "adocim-urunleri.json",
  "soguk-asfalt-urunleri.json",
];

const jsonAl = (yol, bos) =>
  fetch(yol)
    .then((r) => (r.ok ? r.json() : bos))
    .catch(() => bos);

// Sayfalar arasında gezerken dosyalar bir kez indirilir.
let urunSozu = null;
let dizinSozu = null;
let adSozu = null;

export const urunleriYukle = () =>
  (urunSozu ||= Promise.all(
    URUN_DOSYALARI.map((d) =>
      jsonAl(`/data/${d}`, []).then((v) =>
        (Array.isArray(v) ? v : []).map((u) => ({ ...u, _dosya: d }))
      )
    )
  ).then((l) => l.flat()));

/** slug -> üst slug ("" = ana kategori) */
export const dizinYukle = () =>
  (dizinSozu ||= jsonAl("/data/_kategori-dizini.json", {}));

/** slug -> [tr, en, fr, ar] */
export const kategoriAdlariYukle = () =>
  (adSozu ||= jsonAl("/data/_kategori-adlari.json", {}));

const DIL_SIRASI = { tr: 0, en: 1, fr: 2, ar: 3 };

export const kategoriAdi = (adlar, slug, lang = "tr") => {
  const k = adlar?.[slug];
  if (!k) return (slug || "").replace(/-/g, " ");
  return k[DIL_SIRASI[lang] ?? 0] || k[0];
};

/** Kökten başlayarak kategori zinciri: ["boya-firca-ve-rulo-grubu", "boya-rulolari"] */
export const kategoriZinciri = (dizin, slug) => {
  const zincir = [];
  const gorulen = new Set();
  let s = slug;
  while (s && dizin && !gorulen.has(s)) {
    gorulen.add(s);
    zincir.unshift(s);
    s = dizin[s];
  }
  return zincir;
};

/** "Ispatula" / "ıspatula" / "ispatula" hepsi eşleşsin diye Türkçe harfleri sadeleştirir. */
export const aramaMetni = (s) =>
  (s || "")
    .toLocaleLowerCase("tr")
    .replace(/ı/g, "i")
    .replace(/ş/g, "s")
    .replace(/ğ/g, "g")
    .replace(/ü/g, "u")
    .replace(/ö/g, "o")
    .replace(/ç/g, "c")
    .trim();

/** Ürün adresi: /urun/<id> */
export const urunYolu = (urun) => `/urun/${encodeURIComponent(urun.id)}`;

/** Katalog, dizin ve kategori adlarını birlikte yükler. */
export function useKatalog() {
  const [durum, setDurum] = useState({ urunler: [], dizin: null, adlar: null, hazir: false });

  useEffect(() => {
    let iptal = false;
    Promise.all([urunleriYukle(), dizinYukle(), kategoriAdlariYukle()]).then(
      ([urunler, dizin, adlar]) => {
        if (!iptal) setDurum({ urunler, dizin, adlar, hazir: true });
      }
    );
    return () => {
      iptal = true;
    };
  }, []);

  return durum;
}
